// Author Lin
// Date 2021-11-20 09:44:08

class MintalMesPrdPelletizingRoastingParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                beltSpeed = '',
                baseMaterialThickness = '',
                frequency601 = '',
                dryHoopPressureOne = '',
                dryHoopTempOne = '',
                dryBellowsPressureOne = '',
                dryBellowsTempOne = '',
                frequency602 = '',
                dryHoopPressureTwo = '',
                dryHoopTempTwo = '',
                dryBellowsPressureTwo = '',
                dryBellowsTempTwo = '',
                frequency603 = '',
                heatingHoopPressure = '',
                heatingHoopTemp = '',
                heatingBellowsPressure = '',
                heatingBellowsTemp = '',
                frequency604 = '',
                roastingHoopPressure = '',
                roastingHoopTemp = '',
                roastingBellowsPressure = '',
                roastingBellowsTemp = '',
                soakingTemp = '',
                coolingAirQuantityOne = '',
                coolingHoopPressureOne = '',
                coolingHoopTempOne = '',
                coolingAirQuantityTwo = '',
                coolingHoopPressureTwo = '',
                coolingHoopTempTwo = '',
                coolingAirQuantityThree = '',
                coolingHoopPressureThree = '',
                coolingHoopTempThree = '',
                supportingAirOne = '',
                gasFlowOne = '',
                powerOne = '',
                supportingAirTwo = '',
                gasFlowTwo = '',
                powerThree = '',
                openingDegree = '',
                waterLevelOne = '',
                differentialPressureOne = '',
                wasteGasTempOne = '',
                waterLeverTwo = '',
                differentialPressureTwo = '',
                wasteGasTempTwo = '',
                waterLevelThree = '',
                differentialPressureThree = '',
                wasteGasTempThree = '',
                ph603 = '',
                waterLevelFour = '',
                differentialPressureFour = '',
                wasteGasTempFour = '',
                ph604 = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.beltSpeed = beltSpeed;
            this.baseMaterialThickness = baseMaterialThickness;
            this.frequency601 = frequency601;
            this.dryHoopPressureOne = dryHoopPressureOne;
            this.dryHoopTempOne = dryHoopTempOne;
            this.dryBellowsPressureOne = dryBellowsPressureOne;
            this.dryBellowsTempOne = dryBellowsTempOne;
            this.frequency602 = frequency602;
            this.dryHoopPressureTwo = dryHoopPressureTwo;
            this.dryHoopTempTwo = dryHoopTempTwo;
            this.dryBellowsPressureTwo = dryBellowsPressureTwo;
            this.dryBellowsTempTwo = dryBellowsTempTwo;
            this.frequency603 = frequency603;
            this.heatingHoopPressure = heatingHoopPressure;
            this.heatingHoopTemp = heatingHoopTemp;
            this.heatingBellowsPressure = heatingBellowsPressure;
            this.heatingBellowsTemp = heatingBellowsTemp;
            this.frequency604 = frequency604;
            this.roastingHoopPressure = roastingHoopPressure;
            this.roastingHoopTemp = roastingHoopTemp;
            this.roastingBellowsPressure = roastingBellowsPressure;
            this.roastingBellowsTemp = roastingBellowsTemp;
            this.soakingTemp = soakingTemp;
            this.coolingAirQuantityOne = coolingAirQuantityOne;
            this.coolingHoopPressureOne = coolingHoopPressureOne;
            this.coolingHoopTempOne = coolingHoopTempOne;
            this.coolingAirQuantityTwo = coolingAirQuantityTwo;
            this.coolingHoopPressureTwo = coolingHoopPressureTwo;
            this.coolingHoopTempTwo = coolingHoopTempTwo;
            this.coolingAirQuantityThree = coolingAirQuantityThree;
            this.coolingHoopPressureThree = coolingHoopPressureThree;
            this.coolingHoopTempThree = coolingHoopTempThree;
            this.supportingAirOne = supportingAirOne;
            this.gasFlowOne = gasFlowOne;
            this.powerOne = powerOne;
            this.supportingAirTwo = supportingAirTwo;
            this.gasFlowTwo = gasFlowTwo;
            this.powerThree = powerThree;
            this.openingDegree = openingDegree;
            this.waterLevelOne = waterLevelOne;
            this.differentialPressureOne = differentialPressureOne;
            this.wasteGasTempOne = wasteGasTempOne;
            this.waterLeverTwo = waterLeverTwo;
            this.differentialPressureTwo = differentialPressureTwo;
            this.wasteGasTempTwo = wasteGasTempTwo;
            this.waterLevelThree = waterLevelThree;
            this.differentialPressureThree = differentialPressureThree;
            this.wasteGasTempThree = wasteGasTempThree;
            this.ph603 = ph603;
            this.waterLevelFour = waterLevelFour;
            this.differentialPressureFour = differentialPressureFour;
            this.wasteGasTempFour = wasteGasTempFour;
            this.ph604 = ph604;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingRoastingParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'beltSpeed',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.beltSpeed',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'baseMaterialThickness',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.baseMaterialThickness',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'frequency601',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.frequency601',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryHoopPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryHoopPressureOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryHoopTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryHoopTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryBellowsPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryBellowsPressureOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryBellowsTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryBellowsTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'frequency602',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.frequency602',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryHoopPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryHoopPressureTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryHoopTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryHoopTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryBellowsPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryBellowsPressureTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dryBellowsTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.dryBellowsTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'frequency603',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.frequency603',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatingHoopPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.heatingHoopPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatingHoopTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.heatingHoopTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatingBellowsPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.heatingBellowsPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatingBellowsTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.heatingBellowsTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'frequency604',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.frequency604',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'roastingHoopPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.roastingHoopPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'roastingHoopTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.roastingHoopTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'roastingBellowsPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.roastingBellowsPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'roastingBellowsTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.roastingBellowsTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'soakingTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.soakingTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingAirQuantityOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingAirQuantityOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopPressureOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingAirQuantityTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingAirQuantityTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopPressureTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingAirQuantityThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingAirQuantityThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopPressureThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopPressureThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coolingHoopTempThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.coolingHoopTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'supportingAirOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.supportingAirOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'gasFlowOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.gasFlowOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'powerOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.powerOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'supportingAirTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.supportingAirTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'gasFlowTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.gasFlowTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'powerThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.powerThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'openingDegree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.openingDegree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'waterLevelOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.waterLevelOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'differentialPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.differentialPressureOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wasteGasTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.wasteGasTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'waterLeverTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.waterLeverTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'differentialPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.differentialPressureTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wasteGasTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.wasteGasTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'waterLevelThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.waterLevelThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'differentialPressureThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.differentialPressureThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wasteGasTempThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.wasteGasTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ph603',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.ph603',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'waterLevelFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.waterLevelFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'differentialPressureFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.differentialPressureFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'wasteGasTempFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.wasteGasTempFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'ph604',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.ph604',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            beltSpeedFilter : '',
            baseMaterialThicknessFilter : '',
            frequency601Filter : '',
            dryHoopPressureOneFilter : '',
            dryHoopTempOneFilter : '',
            dryBellowsPressureOneFilter : '',
            dryBellowsTempOneFilter : '',
            frequency602Filter : '',
            dryHoopPressureTwoFilter : '',
            dryHoopTempTwoFilter : '',
            dryBellowsPressureTwoFilter : '',
            dryBellowsTempTwoFilter : '',
            frequency603Filter : '',
            heatingHoopPressureFilter : '',
            heatingHoopTempFilter : '',
            heatingBellowsPressureFilter : '',
            heatingBellowsTempFilter : '',
            frequency604Filter : '',
            roastingHoopPressureFilter : '',
            roastingHoopTempFilter : '',
            roastingBellowsPressureFilter : '',
            roastingBellowsTempFilter : '',
            soakingTempFilter : '',
            coolingAirQuantityOneFilter : '',
            coolingHoopPressureOneFilter : '',
            coolingHoopTempOneFilter : '',
            coolingAirQuantityTwoFilter : '',
            coolingHoopPressureTwoFilter : '',
            coolingHoopTempTwoFilter : '',
            coolingAirQuantityThreeFilter : '',
            coolingHoopPressureThreeFilter : '',
            coolingHoopTempThreeFilter : '',
            supportingAirOneFilter : '',
            gasFlowOneFilter : '',
            powerOneFilter : '',
            supportingAirTwoFilter : '',
            gasFlowTwoFilter : '',
            powerThreeFilter : '',
            openingDegreeFilter : '',
            waterLevelOneFilter : '',
            differentialPressureOneFilter : '',
            wasteGasTempOneFilter : '',
            waterLeverTwoFilter : '',
            differentialPressureTwoFilter : '',
            wasteGasTempTwoFilter : '',
            waterLevelThreeFilter : '',
            differentialPressureThreeFilter : '',
            wasteGasTempThreeFilter : '',
            ph603Filter : '',
            waterLevelFourFilter : '',
            differentialPressureFourFilter : '',
            wasteGasTempFourFilter : '',
            ph604Filter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'beltSpeed',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.beltSpeed',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'baseMaterialThickness',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.baseMaterialThickness',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'frequency601',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.frequency601',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryHoopPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryHoopPressureOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryHoopTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryHoopTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryBellowsPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryBellowsPressureOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryBellowsTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryBellowsTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'frequency602',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.frequency602',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryHoopPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryHoopPressureTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryHoopTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryHoopTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryBellowsPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryBellowsPressureTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dryBellowsTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.dryBellowsTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'frequency603',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.frequency603',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatingHoopPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.heatingHoopPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatingHoopTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.heatingHoopTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatingBellowsPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.heatingBellowsPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatingBellowsTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.heatingBellowsTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'frequency604',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.frequency604',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'roastingHoopPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.roastingHoopPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'roastingHoopTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.roastingHoopTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'roastingBellowsPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.roastingBellowsPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'roastingBellowsTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.roastingBellowsTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'soakingTemp',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.soakingTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingAirQuantityOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingAirQuantityOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopPressureOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingAirQuantityTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingAirQuantityTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopPressureTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingAirQuantityThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingAirQuantityThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopPressureThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopPressureThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coolingHoopTempThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.coolingHoopTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'supportingAirOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.supportingAirOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'gasFlowOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.gasFlowOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'powerOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.powerOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'supportingAirTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.supportingAirTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'gasFlowTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.gasFlowTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'powerThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.powerThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'openingDegree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.openingDegree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'waterLevelOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.waterLevelOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'differentialPressureOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.differentialPressureOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'wasteGasTempOne',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.wasteGasTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'waterLeverTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.waterLeverTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'differentialPressureTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.differentialPressureTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'wasteGasTempTwo',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.wasteGasTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'waterLevelThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.waterLevelThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'differentialPressureThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.differentialPressureThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'wasteGasTempThree',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.wasteGasTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ph603',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.ph603',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'waterLevelFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.waterLevelFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'differentialPressureFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.differentialPressureFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'wasteGasTempFour',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.wasteGasTempFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'ph604',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.ph604',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingRoastingParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingRoastingParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        